import {
  buildApplyStageRoutePath,
  useDefineProviderRoute,
} from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"
import { StepperId } from "@/models/stepper/stepper-id"

const providerKey: StaticProviderKey = "ads_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsPrequalifiedView.vue"),
    meta: {
      preventBack: true,
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),

  defineRoute({
    path: "/apply/prequalify/:planCode/review",
    inherit: true,
    redirect: (to) => {
      return buildApplyStageRoutePath(
        to.params.providerKey as string,
        "/terms",
        { params: { ...to.params, applyStage: "offer" } }
      )
    },
  }),

  defineRoute({
    path: "/apply/responses/pending_offer",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsPendingOfferView.vue"),
  }),

  defineRoute({
    path: "/apply/full/terms",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsApplyTermsView.vue"),
    meta: {
      step: "terms",
      stepper: StepperId.APPLY,
    },
  }),

  defineRoute({
    path: "/apply/offer/terms",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsApplyTermsView.vue"),
    meta: {
      step: "terms",
      stepper: StepperId.APPLY,
    },
  }),

  defineRoute({
    path: "/apply/prequalify/responses/approved",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsAccountFoundView.vue"),
    meta: {
      preventBack: true,
      step: "decision",
    },
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/approved",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsApprovedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/pending_full",
    inherit: true,
    component: () =>
      // pending uses same view as declined
      import("@/providers/ads_standard/views/AdsDeclinedView.vue"),
    meta: {
      step: "decision",
    },
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/declined",
    inherit: true,
    component: () =>
      import("@/providers/ads_standard/views/AdsDeclinedView.vue"),
  }),
]
